import React, { useState, useEffect } from 'react';
import { faAddressCard, faFileSignature, faPeopleCarry, faStoreAlt, faStoreAltSlash, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
//Utils
import { getData } from '../utils/api';
//Components
import FloatButton from '../components/float_button/float_button';
//Sessions
import { Home, Promo, About, Features, Team, Contact, RoadMap, Testimonials } from './sessions/index';
//Imgs
import homeImage from '../img/home-background.gif';
import aboutImage from '../img/hand-plant.png';
import teamImg1 from '../img/pablo.png';
import teamImg2 from '../img/isabela.png';
import featuresImage from '../img/features-bg.png';
//
export default function Lading(props){
    const [loteOne, setLoteOne] = useState(true);
    const [loteTwo, setLoteTwo] = useState(true);
    const [loteTree, setLoteTree] = useState(true);
    useEffect(()=>{
        getData('/lotes', (data)=>{
            setLoteOne(data.lote_1);
            setLoteTwo(data.lote_2);
            setLoteTree(data.lote_3);
        });
    }, [props]);
    return(
        <>
            <FloatButton icon={faPhoneAlt} url="https://api.whatsapp.com/send?phone=55071993207963"/>
            <Home id="home" image={homeImage} 
                            title='E V O L U I R' 
                            text={`Uma proposta de capacitação à prática da psicoterapia e de independência na carreira através do planejamento da prestação de serviço. \n Aulas expositivas on-line e ao vivo. Veja o cronograma.`} 
                            formTitle='Descubra mais!'
            />
            <About id="sobre" title='Sementes Plantadas nesse curso:'
                                text='Possibilitar a inserção da Clínica de Psicologia com segurança e assertividade. Gerando fonte de receita e realização profissional, proporcionando sonhos e obejtivos se tornarem reais.'
                                list={[
                                        'Inserção na clínica de psicologia com segurança e assertividade.',
                                        'Possibilidade de uma fonte de renda.',
                                        'Realização profissional e pessoal.',
                                        'Escada para outros sonhos e objetivos.',
                                        'Despertar para um novo mindset.'
                                    ]}
                                image={aboutImage}
            />
            <Features id="funcionalidades" image={featuresImage}
                                            featuresList={[
                                                            {
                                                                title: 'Documentos da Clínica',
                                                                text: 'Protuários; Anamnese; Declaração; Atestado. Modelos de documentos para usar na clínica.',
                                                                icon: faAddressCard
                                                            },
                                                            {
                                                                title: 'Desenvolvimento da Carreira',
                                                                text: 'Ferramenta para te ajudar a pensar e planejar a sua carreira.',
                                                                icon: faPeopleCarry
                                                            },
                                                            {
                                                                title: 'Certificado',
                                                                text: 'Certificado de 10 horas.',
                                                                icon: faFileSignature
                                                            }
                                                        ]}
            />
            <Testimonials id="testemunhas" title="O que dizem sobre nós?" 
                                            text="Nossos facilitadores estão sempre recebendo feedbacks e ouvindo o que dizem sobre todas as nossas contribuições."
                                            testimonialsList={[
                                                                    {
                                                                        name:"Gaspar Rodrigues",
                                                                        where:"Facebook",
                                                                        say:"Parabéns um profissional completo ,acolhedor, competente e especializado...que muito me auxiliou...recomendo a todos...um grande abraço querido tamu junto."
                                                                    },
                                                                    {
                                                                        name:"Aline Silva",
                                                                        where:"Instagram",
                                                                        say:"Obrigado pela palestra maravilhosa, enriquecedora em detalhes e conhecimento. Parabéns👏"
                                                                    },
                                                                    {
                                                                        name:"Alana Barbosa",
                                                                        where:"Instagram",
                                                                        say:"Palestra maravilhosa e com uma temática importantíssima."
                                                                    }
                                                                ]}
            />
            <RoadMap id="roadmap" title='O suficiente para o início da atuação clínica.' 
                                    text= '"Psicoterapia passo a passo". Módulos e aulas pensadas para psicólogos e estudantes de psicologia, afim de auxiliá-los a ingressar na atuação clínica. Os módulos vão qualifica-los para o manejo clínico e trazer independência na carreira.'
                                    roadMap={[
                                                {
                                                    title:'Passo 01 \n 27/10/20',
                                                    text:'Como iniciar a minha 1ª sessão de terapia  \n Como as noções de empreendorismo e administração podem te ajudar. \n Introdução da modelagem de negócio.',
                                                    dateOne:'19:30',
                                                    dateTwo:'21:30'
                                                },
                                                {
                                                    title:'Passo 02 \n 29/10/20',
                                                    text:'Atendimento - Documentos necessários. \n Definindo o segmento de clientes. \n Melhor estratégia de relacionamento. \n Por onde disponibilizar seu serviço?',
                                                    dateOne:'19:30',
                                                    dateTwo:'21:30'
                                                },
                                                {
                                                    title:'Passo 03 \n 31/10/20',
                                                    text:'Direcionamento nas sessões, abordagens, nincho terapêutico e rede de encaminhamentos. \n Valor x Preço. \n Qual problema você ajuda a resolver? \n Tornando um serviço diferenciado.',
                                                    dateOne:'09:00',
                                                    dateTwo:'11:00'
                                                },
                                                {
                                                    title:'Passo 04 \n 03/11/20',
                                                    text:'Psicoterapia Online e presencial: documentos necessários para o paciente e para o profissional. \n O que não pode faltar. \n O que você precisa desenvolver em si.',
                                                    dateOne:'19:30',
                                                    dateTwo:'21:30'
                                                },
                                                {
                                                    title:'Passo 05 \n 05/11/20',
                                                    text:'Possibilidades de atuações da/o psicóloga/o clínica/o. \n Documentos do psicólogo autônomo: um olhar nas possibilidades empreendedoras. De onde virá o dinheiro? \n Quais dívidas tenho que encarar?',
                                                    dateOne:'19:30',
                                                    dateTwo:'21:30'
                                                }
                                            ]}
            />
            <Promo id="promo" title='Como adquirir?' 
                            text={`Nosso curso estará disponível em três lotes que estarão listados aqui mesmo. \n Após confirmado o pagamento enviaremos um e-mail com todas as instruções.`}
                            promoList={[
                                            {
                                                icon: loteOne ? faStoreAltSlash : faStoreAlt,
                                                name: '1º LOTE',
                                                price: loteOne ? 'R$ --.--' : 'R$ 50.00',
                                                text: 'Disponível a partir do dia 13/10 até 17/10',
                                                link: "https://www.sympla.com.br/psicoterapia-passo-a-passo__1013774",
                                                disabled: loteOne
                                            },
                                            {
                                                icon: loteTwo ? faStoreAltSlash : faStoreAlt,
                                                name: '2º LOTE',
                                                price: loteTwo ? 'R$ --.--' : 'R$ 55.00',
                                                text: 'Disponível a partir do dia 18/10 até 23/10',
                                                link: "https://www.sympla.com.br/psicoterapia-passo-a-passo__1013774",
                                                disabled: loteTwo
                                            },
                                            {
                                                icon: loteTree ? faStoreAltSlash : faStoreAlt,
                                                name: '3º LOTE',
                                                price: loteTree ? 'R$ --.--' : 'R$ 60.00',
                                                text: 'Disponível a partir do dia 24/10 até 27/10',
                                                link: "https://www.sympla.com.br/psicoterapia-passo-a-passo__1013774",
                                                disabled: loteTree
                                            }
                                        ]}
            />
            <Team id="time" title='Nossos Facilitadores' 
                            text='Em nossa equipe buscamos ter sempre profissionais interdisciplinares, competentes, atenciosos e que amem psicologia.'
                            teamList={[
                                        {
                                            name: 'Pablo Roberto',
                                            office: 'Psicólogo Organizacional',
                                            img: teamImg1,
                                            instagram: 'https://www.instagram.com/pablorobertopsicologo/',
                                            facebook: 'https://www.facebook.com/100305808328860?referrer=whatsapp',
                                            linkedin: 'https://www.linkedin.com/in/pablo-roberto-47046b181'
                                        },
                                        {
                                            name: 'Isabela Mendes',
                                            office: 'Psicóloga Clínica',
                                            img: teamImg2,
                                            instagram: 'https://www.instagram.com/isabelamendespsi/',
                                            facebook: 'https://www.facebook.com/isabelamendespsi',
                                            linkedin: 'https://www.linkedin.com/in/isabela-mendes-150864140'
                                        }
                                    ]}
            />
            <Contact id="contato" title='Entre em contato conosco:'
                                    text={`Nossa equipe estará sempre a disposição para tirar dúvidas, receber sugestões e muito mais! \n Entre em contato conosco, retornaremos em seu e-mail o mais breve possível.`}
                                    contactList={[
                                                    "+55 71 9 9320-7963",
                                                    "+55 71 9 9191-7221",
                                                    "psievoluir.01@gmail.com",
                                                ]} 
            />
        </>
    );
};